<template>
  <v-app
    style="overflow: hidden"
    :style="{
      backgroundColor: isDark ? '#000000' : '#FFFFFF',
      color: isDark ? '#FFFFFF' : '#333333'
    }"
  >
    <v-container style="min-height: 100vh;">
      <div class="row my-8 center" v-if="loading">
        <v-progress-circular color="#E400A0" indeterminate class="p-4">
        </v-progress-circular>
      </div>
      <span v-else>
        <v-row v-if="isDevelop">
          <c-btn class="mx-1" color="secondary" @click="switchAuto()">auto</c-btn>
          <c-btn class="mx-1" color="secondary" @click="switchManual()">manual</c-btn>
          <c-btn class="mx-1" color="secondary" @click="switchYoti()">yoti</c-btn>
        </v-row>
        <v-row style="margin-bottom: 15px;">
          <v-col
            :cols="isMobile ? 12 : 9"
            class="align-center"
            style="margin: auto;text-align: center"
          >
            <v-row style="margin-top: 50px;">
              <v-col cols="12">
                <router-link :to="{ name: 'home' }">
                  <img
                    :src="`/images/${brandingLogo}.svg?dfk23`"
                    width="300"
                    height="48"
                  />
                </router-link>
              </v-col>
              <v-col
                cols="12"
                style="margin-top: 15px;line-height: 30px;"
                :style="{ textAlign: section < 3 ? 'left' : 'center' }"
              >
                <span class="tit-seccion fix fuente-destacada" v-if="section < 3"
                ><span
                  class="tit-seccion fuente-destacada"
                  :style="{ color: project.primary_color }"
                > ON </span
                >
                  BOARDING</span
                >
                <br />
                <span class="tit-seccion fuente-destacada"
                ><span
                  class="tit-seccion fuente-destacada"
                  :style="{ color: project.primary_color }"
                >{{
                    $t(`models.user.on_board.${getSection.name}.title`)
                  }}</span
                >
                  {{
                    $t(`models.user.on_board.${getSection.name}.subtitle`)
                  }}</span
                >
                <br />
                <br />
                <p class="tit-desc">
                  {{ $t(`models.user.on_board.${getSection.name}.desc`) }}
                </p>
              </v-col>
            </v-row>
            <v-alert type="error" v-if="saveError" icon="warning" dense outlined>
              {{ saveError }}
            </v-alert>
            <VerifyIdenty v-if="!manual" create/>
          </v-col>
          <component :is="getSection.component"
                     :isDark="isDark"
                     v-if="manual"
                     home-button
                     @back="backStep()"
                     @next="getSection.method"
          ></component>
          <TermsDialog
            v-model="showTerms"
            :loading="finishing"
            @submit="requestPromotion"
          />
        </v-row>
      </span>
    </v-container>
    <!--    <app-footer app></app-footer>-->
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import AppFooter from '@/components/layouts/AppFooter'
import SignUpStarFormAccount from '@/views/landing/SignUpStar/SignUpStarFormAccount'
import SignUpStarFormPersonal from '@/views/landing/SignUpStar/SignUpStarFormPersonal'
import SignUpStarFormVerificaton from '@/views/landing/SignUpStar/SignUpStarFormVerificaton'
import SignUpStarFormFinal from '@/views/landing/SignUpStar/SignUpStarFormFinal'
import TermsDialog from '@/components/terms/TermsDialog'
import PromotionRequestedFinished from '@/components/promote/PromotionRequestedFinished'
import VerifyIdenty from '@/components/verifyIdenty/VerifyIdenty'
import UserApi from '@/api/UserApi'

import { ProfileActions, WithdrawActions } from '@/store'
import project from '@/project'

export default {
  name: 'SignUpStarForm',
  components: {
    SignUpStarFormAccount,
    SignUpStarFormPersonal,
    SignUpStarFormVerificaton,
    PromotionRequestedFinished,
    AppFooter,
    TermsDialog,
    VerifyIdenty
  },
  props: {
    username: { type: String, default: null },
    email: { type: String, default: null },
    password: { type: String, default: null }
  },
  data () {
    return {
      sections: [
        {
          name: 'step_one',
          component: SignUpStarFormAccount,
          method: this.updateFormAccount
        },
        {
          name: 'step_two',
          component: SignUpStarFormPersonal,
          method: this.updateFormPersonal
        },
        {
          name: 'step_three',
          component: SignUpStarFormVerificaton,
          method: this.updateFormVerification
        },
        {
          name: 'step_final',
          component: PromotionRequestedFinished,
          method: this.goToHome
        }
      ],
      section: 0,
      telegram: '',
      twitter: '',
      formAccount: {},
      formPersonal: {},
      withdrawData: {},
      formVerification: {},
      saveError: false,
      showTerms: false,
      finishing: false,
      loading: true,
      form: {},
      manual: false,
      yoti: false,
      project
    }
  },
  computed: {
    ...mapState('application', ['isMobile']),
    ...mapState('profile', ['currentUser']),
    brandingLogo () {
      return this.isDark ? 'logo_horizontal_white' : 'logo_horizontal'
    },
    getSection () {
      return this.sections[this.section]
    },
    isDark () {
      return !project.project.includes('loverfans')
    },
    isDevelop () {
      return project.isDevelop
    }
  },
  methods: {
    async updateFormAccount (form) {
      this.formAccount = form
      this.telegram = form.telegram
      this.twitter = form.twitter
      await this.$store.dispatch(
        ProfileActions.UpdateAccountData,
        this.formAccount
      )
      this.nextStep()
    },
    async updateFormPersonal ({ form, withdrawData }) {
      this.formPersonal = { ...form, ...this.formAccount }
      this.withdrawData = { ...withdrawData, notifyRequest: true }
      await this.$store.dispatch(
        ProfileActions.UpdatePersonalData,
        this.formPersonal
      )
      this.nextStep()
    },
    async updateFormVerification (form) {
      this.formVerification = form
      this.showTerms = true
    },
    async sendWithdrawData () {
      if (!this.withdrawData.documentType) { this.withdrawData.documentType = this.formVerification.idDocumentType }
      if (!this.withdrawData.documentNumber) { this.withdrawData.documentNumber = this.formVerification.idDocumentNumber }
      await this.$store.dispatch(WithdrawActions.UpdateData, this.withdrawData)
    },

    async requestPromotion () {
      this.finishing = true
      await this.$store.dispatch(
        ProfileActions.UpdatePromotion,
        this.formVerification
      )
      await this.$store.dispatch(ProfileActions.AcceptStarTerms)
      await this.sendWithdrawData()
      this.showTerms = false
      this.finishing = false
      this.nextStep()
    },

    goToHome () {
      this.$router.replace('/home')
    },
    backStep () {
      if (this.section === 0) {
        this.$router.replace('/login')
      }
      this.section--
    },
    nextStep () {
      this.section++
    },
    switchAuto () {
      this.manual = false
      this.yoti = false
      this.getActualMode()
    },
    switchManual () {
      this.manual = !this.manual
      this.yoti = false
    },
    switchYoti () {
      this.manual = false
      this.yoti = !this.yoti
    },
    async getActualMode () {
      const { data, error } = await UserApi.yotiGetConfig()
      if (!error) {
        this.manual = data.manual
        this.yoti = data.yoti
      } else {
        this.manual = false
        this.yoti = true
      }
    }
  },
  async mounted () {
    if (this.currentUser.role === 'influencer') {
      this.$router.replace('/home')
    } else {
      this.loading = true
      await this.getActualMode()
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tit-seccion {
  font-size: 32px;
  font-weight: bold;
  font-family: "Quicksand", sans-serif;
}

.fuente-destacada {
  font-family: "Quicksand", sans-serif;
}

.tit-desc {
  line-height: 20px;
  font-size: 16px;
  font-family: "Quicksand", sans-serif;
}
.campo-label {
  text-align: left;
  font-size: 16px;
  font-family: "Quicksand", sans-serif;
}

.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  font-family: Quicksand, sans-serif;
}
</style>
